import { ApiError, apiContractRequest } from "./client";

const PUBLIC_STATUSES = new Set(["draft", "published", "maintenance"]);

function projectSettingsContract(projectId) {
  const normalizedProjectId = String(projectId || "").trim();
  if (!normalizedProjectId) {
    throw new TypeError("Se requiere un proyecto para operar la configuración del sitio.");
  }
  return `/api/projects/${encodeURIComponent(normalizedProjectId)}/settings`;
}

function normalizePublicStatus(value) {
  const publicStatus = String(value || "").trim().toLowerCase();
  if (!PUBLIC_STATUSES.has(publicStatus)) {
    throw new TypeError("El estado público debe ser draft, published o maintenance.");
  }
  return publicStatus;
}

function isGenericRouteNotFound(error) {
  const message = String(error?.message || "").trim().toLowerCase();
  const code = String(error?.code || error?.data?.code || "").trim().toUpperCase();
  return (
    error?.status === 404 &&
    (!message || message === "not found" || message === "ruta no encontrada") &&
    (!code || code === "NOT_FOUND")
  );
}

async function publicStatusRequest(projectId, publicStatus) {
  const contract = `${projectSettingsContract(projectId)}/public-status`;
  try {
    return await apiContractRequest(contract, {
      method: "PATCH",
      body: JSON.stringify({ publicStatus: normalizePublicStatus(publicStatus) }),
    });
  } catch (error) {
    if (!isGenericRouteNotFound(error)) throw error;

    throw new ApiError(
      `El backend activo no tiene montado PATCH ${contract}.`,
      404,
      {
        ...(error?.data || {}),
        code: "SITE_SETTINGS_PUBLIC_STATUS_ROUTE_MISSING",
        message: `El backend activo no tiene montado PATCH ${contract}.`,
      },
      { method: "PATCH", path: contract },
    );
  }
}

export const settingsApi = {
  get(projectId) {
    return apiContractRequest(projectSettingsContract(projectId));
  },

  update(projectId, payload) {
    return apiContractRequest(projectSettingsContract(projectId), {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  validatePublication(projectId) {
    return apiContractRequest(`${projectSettingsContract(projectId)}/publication-validation`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  createPreviewToken(projectId) {
    return apiContractRequest(`${projectSettingsContract(projectId)}/preview-token`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  listRevisions(projectId) {
    return apiContractRequest(`${projectSettingsContract(projectId)}/revisions`);
  },

  restoreRevision(projectId, siteRevision) {
    const revision = Number(siteRevision);
    if (!Number.isInteger(revision) || revision < 1) {
      throw new TypeError("La revisión publicada indicada no es válida.");
    }
    return apiContractRequest(
      `${projectSettingsContract(projectId)}/revisions/${revision}/restore`,
      {
        method: "POST",
        body: JSON.stringify({}),
      }
    );
  },

  setPublicStatus(projectId, publicStatus) {
    return publicStatusRequest(projectId, publicStatus);
  },

  publish(projectId) {
    return publicStatusRequest(projectId, "published");
  },
};
